import React, { useContext, useMemo } from "react"
import { UserContext } from "../providers"
import { checkPermission, PermissionsEnum } from "../../utils"
import { PublicLinksInfoContext } from "../providers/PublicLinksInfoProvider"

interface Props {
  permission: PermissionsEnum
  children(hasPermission: boolean): React.ReactElement
}

const PermissionGuard = ({
  permission,
  children,
}: Props): React.ReactElement => {
  const { isPublicLink } = useContext(PublicLinksInfoContext)
  const { user } = useContext(UserContext)

  const hasPermission = useMemo<boolean>(() => {
    return (
      isPublicLink ||
      checkPermission({ user, permission })
    )
  }, [user, permission, isPublicLink])

  return children(hasPermission)
}

export default PermissionGuard
